import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParam, useQueryParams, withDefault } from 'use-query-params';

export function useDeleteAIScript() {
  const qc = useQueryClient();
  const [search] = useQueryParam('text', withDefault(StringParam, ''));
  const [query] = useQueryParams({
    page: withDefault(NumberParam, 1),
    size: withDefault(NumberParam, 10)
  });

  const { page, size } = query;

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await $api.delete(`/v1/chat-flow/${id}`);

      return res.data;
    },
    onSuccess: async data => {
      await qc.invalidateQueries({ queryKey: ['ai-agents-filter', search, page, size] });

      showMessage(data.message, data.accept);
    },
    onError: baseErrorHandler
  });
}
